import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AccountsService {
    accounts = [{
        UserId: '',
        UserName: '',
        AccountingFirmId: '0',
        RoleName: ''
    }];

  constructor(private http: HttpClient) { }
    addAccount(UserId: string, UserName: string, AccountingFirmId: string) {
        this.accounts = [];
        this.accounts.push({ UserId: UserId, UserName: UserName, AccountingFirmId: AccountingFirmId, RoleName: '' });
    }

    getAccount() {
        return this.accounts;
    }

    setAccount(accounts) {
        var act = accounts;
        return this.accounts = accounts;
    }

    clear(): void {
        localStorage.clear();
    }

    logout() {
        this.accounts = [];
        this.clear();
    }

    setbodybackground() {
        var items: any = document.getElementsByTagName('body');
        for (let i = 0; i < items.length; i++) {
            let element = items[i];
            element.style.background = '#fafafa';
        }
    }

    setLoginbackground() {
        var items: any = document.getElementsByTagName('body');
        for (let i = 0; i < items.length; i++) {
            let element = items[i];
            element.style.background = '#0747a6';
        }
    }

  GetAppsettingsB2C() {
    return this.http.get<any>('Account/GetAppsettingsB2C')
  }

  SetDocType() {
    return this.http.get<any>('Account/GetACASilentLoginCredsDetails')
  }

  getAccountPermissions(roleId) {
    return this.http.get<any>(`Account/GetPermissions/` + roleId);
  }

  CheckUserSession() {
    return this.http.get<any>('Account/CheckUserSession');
  }
      
}
